import React, { useContext } from "react";
import { ChatProvider } from "context/Chat";
import { AuthContext } from "context/Auth";
import ChatPage from "components/chat_new/ChatPage";
import Loading from "components/Loading";

const ChatPageWrapper = () => {
  const { user, userLoading } = useContext(AuthContext);

  // Show loading while auth is being determined
  if (userLoading) return <Loading page />;

  return (
    <ChatProvider>
      <ChatPage hideHistory={true} hideGraph={true} />
    </ChatProvider>
  );
};

export default ChatPageWrapper;
